import { createContext, lazy, Suspense, useState } from 'react'

const DefaultState = {
  content: '',
  contactModalIsOpen: false,
  loginModalIsOpen: false,
}

export const ContactSellerModalContext = createContext(DefaultState)

export const ContactSellerModalConsumer = ContactSellerModalContext.Consumer

const ContactModal = lazy(() => import('../ContactSellerModal'))
const LoginModal = lazy(() => import('../../../../../Login/components/LoginModal'))

export function ContactSellerModalProvider({ children }) {
  const [isContactModalOpen, setContactModalOpen] = useState(
    DefaultState.contactModalIsOpen
  )
  const [isLoginModalOpen, setLoginModalOpen] = useState(
    DefaultState.loginModalIsOpen
  )

  const openContactModal = () => {
    if (!App.State.userSignedIn) {
      setLoginModalOpen(true)
    } else {
      setContactModalOpen(true)

      const fixedContact = document.getElementById('fixed-contact-content')

      fixedContact.classList.remove('fixed-contact-show')
      fixedContact.classList.add('fixed-contact-hide')
    }
  }

  const closeContactModal = () => {
    setContactModalOpen(false)

    const fixedContact = document.getElementById('fixed-contact-content')

    fixedContact.classList.remove('fixed-contact-hide')
    fixedContact.classList.add('fixed-contact-show')
  }

  return (
    <>
      <ContactSellerModalContext.Provider
        value={{
          openContactModal,
        }}
      >
        <Suspense
          fallback={<i className="fas fa-2x fa-spinner-third fa-spin" />}
        >
          {isContactModalOpen && (
            <ContactModal
              modalIsOpen={isContactModalOpen}
              closeContactModal={closeContactModal}
            />
          )}
          {isLoginModalOpen && (
            <LoginModal
              modalIsOpen={isLoginModalOpen}
              closeModal={() => setLoginModalOpen(false)}
            />
          )}
          {children}
        </Suspense>
      </ContactSellerModalContext.Provider>
    </>
  )
}
